import React, { useEffect, useState } from "react";
import SelectControl from "../SelecControl/SelectControl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBackspace } from "@fortawesome/free-solid-svg-icons";
import FormNivel1 from "../FormNivel1/FormNivel1";
import FormNivel2 from "../FormNivel2/FormNivel2";
import FormNivel3 from "../FormNivel3/FormNivel3";
import FormNivel4 from "../FormNivel4/FormNivel4";
import FormNivel5 from "../FormNivel5/FormNivel5";
import DictionaryText from "../dictionaryText/DictionaryText";

const RRLogsUbicaciones = ({log, i, modo, nivel1Lista, nivel2List, nivel3List, nivel4List, nivel5List, opciones, handleChange, usuario, handleDelete, opcionesUsers}) =>{

    const [addFormToShow, setAddFormToShow] = useState(false);
    const [nuevoEditado, setNuevoEditado] = useState("Agregar");
    
    const [dataNivel1,setDataNivel1] = useState({})
    const [dataNivel2,setDataNivel2] = useState({})
    const [dataNivel3,setDataNivel3] = useState({});
    const [dataNivel4,setDataNivel4] = useState({});
    const [dataNivel5,setDataNivel5] = useState({});

    useEffect(()=>{
        if(Object.keys(dataNivel1).length > 0){
            handleChange({},i,'nivel1',dataNivel1);
            setDataNivel1({});
        };
        if(Object.keys(dataNivel2).length > 0){
            handleChange({},i,'nivel2',dataNivel2);
            setDataNivel2({});
        }
        if( Object.keys(dataNivel3).length > 0){
            handleChange({},i,'nivel3',dataNivel3);
            setDataNivel3({});
        }
        if( Object.keys(dataNivel4).length > 0){
            handleChange({},i,'nivel4',dataNivel4);
            setDataNivel4({});
        }
        if( Object.keys(dataNivel5).length > 0){
            handleChange({},i,'nivel5',dataNivel5);
            setDataNivel5({});
        }
    },[dataNivel1, dataNivel2, dataNivel3, dataNivel4, dataNivel5]);

    return <div key={i} className={`${(modo == 'Vista') ? 'eightColumns ' : ''}rrLogsUbicacionesDiv`}>

        <div className="firstRowUbicaciones">
            {modo != 'Vista' && <FontAwesomeIcon className="deleteRowUbicaciones" icon={faBackspace} color="red" style={{height: '40px', marginTop: "5px", cursor: "pointer"}} onClick={()=>handleDelete(log,i)}/>}
            
            <div className="inputGroup fechaInput">
                <label>Fecha</label>
                <input style={{flex:1}} className="fechaInput" disabled={modo == 'Vista'} name="fecha" value={log.fecha} type="datetime-local" onChange={(e) => handleChange({}, i , e.target.name, e.target.value)}/>
            </div>

            <div className="inputGroup textAdicInput">
                <label>Texto Adicional</label>
                <input style={{flex:2}} className="textAdicInput" disabled={modo == 'Vista'} name="textAdic" value={log.textAdic} onChange={(e) => handleChange({}, i, e.target.name, e.target.value)} placeholder="Ingrese texto adicional"/>
            </div>

            <div className="inputGroup">
                <label>Usuario</label>
                <SelectControl modo={modo} tipo={'logUbicacionesUser'} setShowAdd={setAddFormToShow} setNuevoEditado={setNuevoEditado} optionsSelect={opcionesUsers} handleChengeSelect={handleChange} index={i} valueSeleccionada={log.user} propToChange="user" placeholder={"Seleccione usuario..."}/>        
            </div>
        </div>

        <div className="secondRowUbicaciones">
            <div className="inputGroup">
                <label><DictionaryText text={"Nivel 1"}/></label>
                <SelectControl modo={modo} tipo={'logUbicaciones'} setShowAdd={setAddFormToShow} setNuevoEditado={setNuevoEditado} optionsSelect={(opciones[i] != undefined) ? opciones[i].opcionesNivel1s : []} handleChengeSelect={handleChange} index={i} valueSeleccionada={log.nivel1} propToChange="nivel1" placeholder={"Seleccione nivel1..."}/>
            </div>
            
            <div className="inputGroup">
                <label><DictionaryText text={"Nivel 2"}/></label>
                <SelectControl modo={modo} tipo={'logUbicaciones'} setShowAdd={setAddFormToShow} setNuevoEditado={setNuevoEditado} optionsSelect={(opciones[i] != undefined) ? opciones[i].opcionesNivel2s : []} handleChengeSelect={handleChange} data={log.nivel1} index={i} valueSeleccionada={log.nivel2} propToChange="nivel2" placeholder={"Seleccione nivel2..."}/>
            </div>
            
            <div className="inputGroup">
                <label><DictionaryText text={"Nivel 3"}/></label>
                <SelectControl modo={modo} tipo={'logUbicaciones'} setShowAdd={setAddFormToShow} setNuevoEditado={setNuevoEditado} optionsSelect={(opciones[i] != undefined) ? opciones[i].opcionesNivel3s : []} handleChengeSelect={handleChange} index={i} data={log.nivel2} valueSeleccionada={log.nivel3} propToChange="nivel3" placeholder={"Seleccione nivel3..."}/>
            </div>

            <div className="inputGroup">
                <label><DictionaryText text={"Nivel 4"}/></label>
                <SelectControl modo={modo} tipo={'logUbicaciones'} setShowAdd={setAddFormToShow} setNuevoEditado={setNuevoEditado} optionsSelect={(opciones[i] != undefined) ? opciones[i].opcionesNivel4s : []} handleChengeSelect={handleChange} data={log.nivel1} index={i} valueSeleccionada={log.nivel4} propToChange="nivel4" placeholder={"Seleccione nivel4..."}/>
            </div>

            <div className="inputGroup">
                <label><DictionaryText text={"Nivel 5"}/></label>
                <SelectControl modo={modo} tipo={'logUbicaciones'} setShowAdd={setAddFormToShow} setNuevoEditado={setNuevoEditado} optionsSelect={(opciones[i] != undefined) ? opciones[i].opcionesNivel5s : []} handleChengeSelect={handleChange} data={log.nivel1} index={i} valueSeleccionada={log.nivel5} propToChange="nivel5" placeholder={"Seleccione nivel5..."}/>
            </div>
        </div>

        {(addFormToShow == 'nivel1') &&
                <div className='modalUser'>
                    <FormNivel1
                        setData={setDataNivel1}
                        data={ log.nivel1 }
                        formDato={log}
                        nuevoEditado={nuevoEditado}
                        minimizar={(dato) =>(setAddFormToShow(''))}
                        handleChangeUbicaciones = {handleChange}
                        i={i}
                    />
                </div>
            }

            {(addFormToShow == 'nivel2') &&
                <div className='modalUser'>
                    <FormNivel2
                        data={log.nivel2}
                        setData={setDataNivel2}
                        formDato={log}
                        nuevoEditado={nuevoEditado}
                        minimizar={(dato) =>(setAddFormToShow(''))}
                        optionsNivel1={opciones.opcionesNivel1s}
                        nivel1Lista={nivel1Lista}   
                        areaSeleccionada={log.nivel1} 
                        modo={modo}
                        handleChangeUbicaciones = {handleChange}
                        i={i}
                    />
                </div>
            }

            {(addFormToShow == 'nivel3') &&
                <div className='modalUser'>
                    <FormNivel3
                         data={log.nivel3}
                         setData={setDataNivel3}
                         nuevoEditado={nuevoEditado}
                         formDato={log}
                         minimizar={() =>(setAddFormToShow(''))}
                         optionsNivel2={opciones.opcionesNivel2s}
                         nivel2List={nivel2List}   
                         nivel2Seleccionada={log.nivel2} 
                         modo={modo}
                         handleChangeUbicaciones = {handleChange}
                         i={i}
                    />
                </div>
            }

            {(addFormToShow == 'nivel4') &&
                <div className='modalUser'>
                    <FormNivel4
                        data={log.nivel4}
                        setData={setDataNivel4}
                        formDato={log}
                        nuevoEditado={nuevoEditado}
                        minimizar={(dato) =>(setAddFormToShow(''))}
                        optionsNivel3={opciones.opcionesNivel3s}
                        nivel3Lista={nivel3List}   
                        nivel3Seleccionado={log.nivel3} 
                        modo={modo}
                        handleChangeUbicaciones = {handleChange}
                        i={i}
                    />
                </div>
            }

            {(addFormToShow == 'nivel5') &&
                <div className='modalUser'>
                    <FormNivel5
                        data={log.nivel5}
                        setData={setDataNivel5}
                        formDato={log}
                        nuevoEditado={nuevoEditado}
                        minimizar={(dato) =>(setAddFormToShow(''))}
                        optionsNivel4={opciones.opcionesNivel4s}
                        nivel4Lista={nivel4List}   
                        nivel4Seleccionado={log.nivel4} 
                        modo={modo}
                        handleChangeUbicaciones = {handleChange}
                        i={i}
                    />
                </div>
            }
    </div>
}

export default RRLogsUbicaciones